import { useEffect, useState } from "react";
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient";
import ProdutosLista from "./ProdutosLista";

export default function LocalProdutosLista({ local }: iProps) {

    const [produtosDados, setProdutosDados] = useState<any[]>([])
    const [produtoOptions, setProdutoOptions] = useState<any[]>([])
    const [unidadesDados, setUnidadesDados] = useState<any[]>([])
    const [unidadeOptions, setUnidadeOptions] = useState<any[]>([])

    useEffect(() => {
        const loadOptions = async () => {
            const apiProdutos = await reqGetNew(ApiEndpoints.insumosProdutos)
            const apiUnidades = await reqGetNew(ApiEndpoints.insumosUnidades)
            if (apiProdutos.status !== 200 || apiUnidades.status !== 200) {
                return
            }
            let produtos = apiProdutos.data
            setProdutosDados(produtos)
            let produtosAux: any[] = produtos.map((prod: any, index: any) => (
                {
                    "value": prod.id_produto,
                    "label": `#${prod.id_produto} ${prod.descricao}`
                }
            ))
            produtosAux.unshift({ value: 0, label: "Não Selecionado" })
            setProdutoOptions(produtosAux)
            let unidades = apiUnidades.data
            setUnidadesDados(unidades)
            let unidadesAux: any[] = unidades.map((unid: any, index: any) => (
                {
                    "value": unid.id_unidade,
                    "label": `${unid.descricao}`
                }
            ))
            unidadesAux.unshift({ value: 0, label: "Não Selecionado" })
            setUnidadeOptions(unidadesAux)
        }
        loadOptions()
    }, [])

    return (
        <div>
            <br></br>
            <p style={{ fontWeight: "bold" }}>Lista de Produtos</p>
            <br></br>
            <ProdutosLista local={local} produtosDados={produtosDados} produtoOptions={produtoOptions} unidadesDados={unidadesDados} unidadeOptions={unidadeOptions} />
            <br></br>
        </div>
    )
}
interface iProps {
    local: any
}
